import React from "react";
import { Outlet } from "react-router-dom";

const EmailLog: React.FC = () => {
  return <Outlet />;
};

export default EmailLog;
